angular.module('shared').factory('TasksService', ["EmploymentService", "ReactModal", function(EmploymentService, ReactModal) {
  return {
    create: function(params) {
      return ReactModal.open({
        component: 'EditTask',
        windowClass: 'drawer__wrapper',
        backdropClass: 'modal-backdrop--drawer',
        props: {
          contactId: params != null ? params.contactId : void 0
        }
      });
    },
    edit: function(id) {
      return ReactModal.open({
        component: 'EditTask',
        windowClass: 'drawer__wrapper',
        backdropClass: 'modal-backdrop--drawer',
        props: {
          taskId: id
        }
      });
    },
    show: function(id) {
      return ReactModal.open({
        component: 'ShowTask',
        drawer: true,
        props: {
          taskId: id
        }
      });
    },
    isAssignedToCurrentUser: function(task) {
      return window.currentUser.id === (task != null ? task.user_id : void 0);
    },
    hasManagePermission: function(task) {
      var permissions;
      permissions = EmploymentService.get().permissions;
      return (permissions.manage_tasks && this.isAssignedToCurrentUser(task)) || permissions.manage_other_users_tasks;
    },
    hasDeletePermission: function(task) {
      var permissions;
      permissions = EmploymentService.get().permissions;
      return (permissions.delete_tasks && this.isAssignedToCurrentUser(task)) || permissions.manage_other_users_tasks;
    },
    getStatuses: function() {
      return [['unstarted', 'Not Started'], ['started', 'In Progress'], ['waiting', 'Waiting'], ['finished', 'Complete']];
    }
  };
}]);
